/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./cloud-clip.vue?vue&type=template&id=3c8d0a46&scoped=true&"
import script from "./cloud-clip.vue?vue&type=script&lang=js&"
export * from "./cloud-clip.vue?vue&type=script&lang=js&"
import style0 from "./cloud-clip.vue?vue&type=style&index=0&id=3c8d0a46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8d0a46",
  null
  
)

export default component.exports